"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var i18next_1 = __importDefault(require("i18next"));

var preact_1 = require("preact"); // 알림 항목 아이콘 출력


function Icon(_ref) {
  var type = _ref.type;

  switch (type) {
    case "F01":
    case "F21":
      return preact_1.h("em", {
        class: "icf_live"
      }, i18next_1.default.t("BJ 새 방송 알림"));

    case "F03":
    case "F04":
    case "F05":
      return preact_1.h("em", {
        class: "icf_vod"
      }, i18next_1.default.t("BJ 새 VOD 알림"));

    case "F02":
      return preact_1.h("em", {
        class: "icf_bj_post"
      }, i18next_1.default.t("BJ 새 게시글 알림"));

    case "F12":
      return preact_1.h("em", {
        class: "icf_bj_post"
      }, i18next_1.default.t("BJ 매니저의 새 게시글 알림"));

    case "F06":
      return preact_1.h("em", {
        class: "icf_bj_text"
      }, i18next_1.default.t("BJ 새 방명록 글 알림"));

    case "F11":
      return preact_1.h("em", {
        class: "icf_bj_msg"
      }, i18next_1.default.t("BJ 메시지 알림"));

    case "A01":
    case "A02":
    case "A03":
    case "A04":
    case "A05":
    case "C11":
    case "C21":
    case "C31":
    case "C14":
    case "C24":
    case "C34":
      return preact_1.h("em", {
        class: "icf_text"
      }, i18next_1.default.t("댓글/답글 알림"));

    case "A07":
    case "A08":
    case "A09":
    case "A10":
    case "A12":
    case "A13":
    case "C17":
    case "C27":
    case "C37":
    case "C19":
    case "C29":
    case "C39":
      return preact_1.h("em", {
        class: "icf_up"
      }, i18next_1.default.t("UP 알림"));

    case "A11":
      return preact_1.h("em", {
        class: "icf_message"
      }, i18next_1.default.t("쪽지 알림"));

    case "B02":
      return preact_1.h("em", {
        class: "icf_mypost"
      }, i18next_1.default.t("새 게시글 알림"));

    case "B06":
      return preact_1.h("em", {
        class: "icf_mytext"
      }, i18next_1.default.t("새 방명록 알림"));

    case "B03":
    case "B04":
    case "B07":
      return preact_1.h("em", {
        class: "icf_myvod"
      }, i18next_1.default.t("VOD 알림"));

    case "S01":
    case "S08":
    case "S02":
    case "S03":
    case "S04":
      return preact_1.h("em", {
        class: "icf_balloon"
      }, i18next_1.default.t("별풍선 알림"));

    case "S05":
    case "S06":
      return preact_1.h("em", {
        class: "icf_sticker"
      }, i18next_1.default.t("스티커 알림"));

    case "S07":
      return preact_1.h("em", {
        class: "icf_choco"
      }, i18next_1.default.t("초콜릿 알림"));

    case "S09":
    case "S10":
    case "S16":
      return preact_1.h("em", {
        class: "icf_ad"
      }, i18next_1.default.t("애드벌룬 알림"));

    case "S11":
    case "S12":
    case "S13":
    case "S14":
      return preact_1.h("em", {
        class: "icf_subscribe"
      }, i18next_1.default.t("구독 알림"));

    case "S15":
      return preact_1.h("em", {
        class: "icf_quickview"
      }, i18next_1.default.t("퀵뷰 알림"));
  }

  return null;
}

exports.default = Icon;